import { render, staticRenderFns } from "./AssignmentTabs.vue?vue&type=template&id=691a53f9&scoped=true"
import script from "./AssignmentTabs.vue?vue&type=script&lang=js"
export * from "./AssignmentTabs.vue?vue&type=script&lang=js"
import style0 from "./AssignmentTabs.vue?vue&type=style&index=0&id=691a53f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a53f9",
  null
  
)

export default component.exports